import { useContext, useRef, useState } from "react";
import { Modal, Button, TextInput, Group } from "@mantine/core";
import { useForm } from "@mantine/form";
import { FoldersContext } from "../contexts/FoldersContext";
import { useEffect } from "react";
import { useFocusTrap } from "@mantine/hooks";

const RenameFolderModal = ({ opened, onClose, folder }) => {
  const { renameFolder } = useContext(FoldersContext);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (opened && folder) {
      form.setValues({ newName: folder.label || "" });
      form.resetDirty();
    }
  }, [opened, folder]);

  const form = useForm({
    initialValues: { newName: folder?.label || "" },
    validate: {
      newName: (value) =>
        value.trim().length > 0 ? null : "Folder name is required",
    },
  });

  const handleSubmit = async (values) => {
    setLoading(true);
    await renameFolder(folder.value, values.newName);
    setLoading(false);
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Rename Folder"
      centered
      keepMounted={false}
      styles={{ title: { fontWeight: 600 } }}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <TextInput label="New Folder Name" {...form.getInputProps("newName")} />
        <Group mt="lg" justify="flex-end">
          <Button onClick={onClose} variant="subtle">
            Cancel
          </Button>
          <Button type="submit" loading={loading}>
            Rename
          </Button>
        </Group>
      </form>
    </Modal>
  );
};

export default RenameFolderModal;
